// Mock data for Nelly & Cyrille Wedding Website

export const weddingData = {
  fr: {
    nav: {
      home: "Accueil",
      ourStory: "Notre Histoire",
      ourPath: "Notre Chemin",
      gallery: "Galerie",
      program: "Programme",
      faq: "FAQ",
      maps: "Cartes",
      infosCI: "Infos CI",
      guestbook: "Livre d'Or",
      accommodation: "Hébergement",
      transport: "Transport",
      contacts: "Contacts",
      practicalInfo: "Infos Pratiques",
      gifts: "Cadeaux",
      rsvp: "RSVP"
    },
    countdown: {
      title: "Plus que",
      days: "Jours",
      hours: "Heures",
      minutes: "Minutes",
      seconds: "Secondes",
      addToCalendar: "Ajouter au calendrier"
    },
    keyMoments: {
      title: "Les Moments Clés",
      subtitle: "Trois célébrations pour sceller notre union",
      civil: {
        title: "Mariage Civil",
        date: "14 août 2026",
        time: "12H00",
        location: "Mairie de Cocody",
        address: "Boulevard des Martyrs, Cocody, Abidjan",
        viewMap: "Voir sur la carte"
      },
      religious: {
        title: "Cérémonie Religieuse",
        date: "14 août 2026",
        time: "15H00",
        location: "Paroisse Sainte Cécile",
        address: "Deux plateaux, Cocody, Abidjan",
        viewMap: "Voir sur la carte"
      },
      reception: {
        title: "Réception",
        date: "14 août 2026",
        time: "18H00",
        location: "Espace JECKAD",
        address: "Angré 7ème tranche, Rue L155, Cocody, Abidjan",
        viewMap: "Voir sur la carte"
      }
    },
    gallery: {
      title: "Galerie Photos",
      subtitle: "Nos plus beaux moments",
      teasing: {
        title: "En Attendant le Grand Jour",
        description: "Découvrez quelques moments de notre histoire avant le mariage"
      },
      wedding: {
        title: "Photos du Mariage",
        description: "Les photos seront ajoutées après le 14 août 2026",
        comingSoon: "Bientôt disponible"
      }
    },
    program: {
      title: "Programme de la Journée",
      subtitle: "Le déroulement de notre journée spéciale",
      comingSoon: "Le programme détaillé sera communiqué prochainement",
      timeline: [
        {
          time: "12H00",
          title: "Cérémonie Civile",
          location: "Mairie de Cocody",
          description: "Cérémonie officielle en présence de nos proches"
        },
        {
          time: "15H00",
          title: "Cérémonie Religieuse",
          location: "Paroisse Sainte Cécile",
          description: "Bénédiction de notre union devant Dieu"
        },
        {
          time: "17H00",
          title: "Cocktail de Bienvenue",
          location: "Espace JECKAD",
          description: "Moment convivial avec nos invités"
        },
        {
          time: "18H00",
          title: "Dîner & Soirée",
          location: "Espace JECKAD",
          description: "Célébration et festivités"
        }
      ]
    },
    faq: {
      title: "Questions Fréquentes",
      subtitle: "Tout ce que vous devez savoir",
      questions: [
        {
          question: "À quelle heure commencent les cérémonies ?",
          answer: "Mariage civil à la Mairie de Cocody à 12H00, cérémonie religieuse à la Paroisse Sainte Cécile à 15H00, cocktail de bienvenue à l'Espace JECKAD à 17H00, puis dîner et soirée à 18H00. Nous vous recommandons d'arriver 30 minutes en avance."
        },
        {
          question: "Puis-je venir accompagné(e) ?",
          answer: "Oui, si vous avez reçu une invitation incluant un accompagnant. Merci de confirmer le nombre exact de personnes lors de votre RSVP."
        },
        {
          question: "Comment confirmer ma présence ?",
          answer: "Rendez-vous dans la section RSVP de ce site et remplissez le formulaire. Vous recevrez un email de confirmation à l'adresse renseignée."
        },
        {
          question: "Où puis-je me loger à Abidjan ?",
          answer: "Nous recommandons les quartiers de Cocody, Deux Plateaux et Plateau. Plusieurs hôtels sont disponibles à différents budgets (de 35€/55 CAD à 150€/225 CAD par nuit). Consultez la section Hébergement pour nos recommandations. Réservez tôt pour de meilleurs tarifs."
        },
        {
          question: "Comment se rendre aux différents lieux ?",
          answer: "Des taxis et VTC (Uber, Yango) sont disponibles partout à Abidjan. Prévoyez du temps supplémentaire pour la circulation. Les adresses exactes et cartes sont disponibles dans les sections Cartes et Infos Pratiques."
        },
        {
          question: "Y aura-t-il un photographe/vidéaste ?",
          answer: "Oui, des professionnels seront présents. N'hésitez pas à prendre vos propres photos et à les partager avec nous !"
        },
        {
          question: "Comment puis-je contribuer pour les cadeaux ?",
          answer: "Votre présence est le plus beau des cadeaux ! Si vous souhaitez contribuer, des liens PayPal et Revolut (avec QR codes) sont disponibles dans la section Cadeaux. Les options Mobile Money seront bientôt disponibles."
        },
        {
          question: "Qui contacter en cas d'urgence le jour J ?",
          answer: "Les numéros d'urgence seront communiqués par email quelques jours avant l'événement."
        },
        {
          question: "Quel est le code vestimentaire ?",
          answer: "Tenue de soirée élégante. Nous suggérons la palette lilas, blanc, doré et tons pastels pour harmoniser avec notre thème."
        },
        {
          question: "Y a-t-il des précautions de sécurité à prendre ?",
          answer: "Abidjan est une ville accueillante. Gardez vos objets de valeur en sécurité et évitez de vous déplacer seul(e) tard le soir. Les zones des cérémonies sont sûres."
        }
      ]
    },
    maps: {
      title: "Lieux des Cérémonies",
      subtitle: "Retrouvez-nous aux adresses suivantes",
      locations: [
        {
          name: "Mairie de Cocody",
          event: "Mariage Civil",
          address: "Boulevard des Martyrs, Cocody, Abidjan",
          mapQuery: "Mairie+de+Cocody,+Abidjan,+Côte+d'Ivoire"
        },
        {
          name: "Paroisse Sainte Cécile",
          event: "Cérémonie Religieuse",
          address: "Deux Plateaux Vallon, Cocody, Abidjan",
          mapQuery: "Paroisse+Sainte+Cécile,+Deux+Plateaux,+Abidjan"
        },
        {
          name: "Espace JECKAD",
          event: "Réception",
          address: "Angré 7ème tranche, Rue L155, Cocody, Abidjan",
          mapQuery: "Espace+JECKAD,+Angré,+Cocody,+Abidjan"
        }
      ]
    },
    ivoryCoastInfo: {
      title: "Bienvenue à Abidjan",
      subtitle: "La perle des lagunes",
      intro: "Quelques informations pratiques pour préparer votre séjour en Côte d'Ivoire",
      sections: [
        {
          title: "Météo en août",
          icon: "sun",
          content: "Températures : 24-28°C. Saison des pluies, prévoyez un parapluie. Humidité élevée."
        },
        {
          title: "Devise",
          icon: "currency",
          content: "Franc CFA (XOF). 1 EUR ≈ 656 FCFA. Changez à l'aéroport ou dans les banques."
        },
        {
          title: "Électricité",
          icon: "plug",
          content: "220V, prises européennes (type C et E). Adaptateur rarement nécessaire."
        },
        {
          title: "Téléphone & Internet",
          icon: "wifi",
          content: "Indicatif +225. Cartes SIM locales (Orange, MTN) disponibles partout. 4G excellent."
        },
        {
          title: "Langue",
          icon: "language",
          content: "Français (officiel). L'anglais est compris dans les hôtels et zones touristiques."
        },
        {
          title: "Transport",
          icon: "car",
          content: "Taxis, VTC (Uber, Yango). Aéroport Félix Houphouët-Boigny (ABJ) à 20-30 min du centre."
        }
      ]
    },
    hero: {
      names: "Nelly & Cyrille",
      subtitle: "Dans la douceur de son regard, j'ai trouvé ma force. Dans la grâce de son cœur, j'ai découvert mon ancre. Nelly, lumière de mes jours, avec toi, l'amour n'est plus un rêve mais une promesse tenue.",
      verse: "Un cordon à trois brins ne se rompt pas facilement",
      verseRef: "Ecclésiaste 4:12",
      cta1: "Découvrir notre histoire",
      cta2: "RSVP",
      date: "14 août 2026"
    },
    ourStory: {
      title: "Notre Histoire",
      intro: "Une histoire tissée de patience, de foi et d'une grâce qui dépasse notre compréhension.",
      paragraphs: [
        "Quand nos chemins se sont croisés, nous ne cherchions pas l'amour. Nous cherchions la paix, la clarté, une direction. Et c'est dans cette recherche que Dieu nous a placés l'un face à l'autre. Nelly, avec sa douceur rare et sa force tranquille, est entrée dans ma vie comme une évidence.",
        "Elle ne crie pas son élégance, elle la porte. Elle ne revendique pas sa force, elle l'incarne. Dans ses silences, j'ai appris l'humilité. Dans son rire, j'ai découvert la joie pure. Dans sa foi inébranlable, j'ai trouvé mon propre courage de croire encore plus grand.",
        "Ce n'est pas une histoire de coup de foudre. C'est une histoire de construction consciente. Jour après jour, nous avons choisi de nous comprendre, de nous soutenir, de grandir ensemble. Nous avons appris que l'amour véritable n'est pas une émotion passagère, mais un engagement quotidien.",
        "Nelly m'a appris la patience. Elle m'a montré que la vraie force se trouve dans la douceur, que la véritable sagesse se nourrit de silence et d'écoute. Avec elle, j'ai compris que se marier n'est pas une fin, mais un commencement – celui d'une vie partagée sous le regard bienveillant de Dieu.",
        "Aujourd'hui, nous choisissons de nous dire oui. Non pas par naïveté, mais par conviction. Non pas par facilité, mais par engagement. Avec vous tous, témoins de notre amour, nous écrivons ce nouveau chapitre de notre histoire."
      ]
    },
    ourPath: {
      title: "Notre Chemin",
      subtitle: "À l'ombre de Sa présence, nous avons grandi ensemble",
      verse: "La grâce est trompeuse et la beauté est vaine ; la femme qui craint l'Éternel est celle qui sera louée.",
      verseRef: "Proverbes 31:30",
      paragraphs: [
        "Notre chemin n'a pas été tracé dans l'agitation, mais dans le silence de la prière. Nous avons marché ensemble, non pas en fuyant nos imperfections, mais en les accueillant avec grâce. À chaque épreuve, nous avons choisi la foi plutôt que la peur. À chaque doute, nous avons choisi la confiance plutôt que le repli.",
        "Dans l'ombre de Sa présence, nous avons appris l'unité. Pas l'uniformité, mais l'harmonie. Nous avons compris que nos différences ne sont pas des obstacles, mais des compléments. Que nos forces se multiplient quand elles sont partagées, et que nos faiblesses s'allègent quand elles sont portées à deux.",
        "Aujourd'hui, nous voyons loin. Une famille construite sur la foi. Un foyer où règnent la paix et la stabilité. Une vie où nos enfants grandiront en sachant qu'ils sont aimés, non par hasard, mais par choix. Ensemble, sous Sa présence, nous bâtissons notre avenir avec confiance."
      ]
    },
    practicalInfo: {
      title: "Informations Pratiques",
      events: {
        title: "Programme des Cérémonies",
        civil: {
          title: "Mariage Civil",
          date: "14 août 2026",
          time: "12H00",
          location: "Abidjan, Côte d'Ivoire"
        },
        religious: {
          title: "Cérémonie Religieuse",
          date: "14 août 2026",
          time: "15H00",
          location: "Paroisse Sainte Cécile des 2 Plateaux Vallon, Abidjan"
        },
        reception: {
          title: "Réception",
          date: "14 août 2026",
          time: "18H00",
          location: "Espace JECKAD, Abidjan"
        }
      },
      dressCode: {
        title: "Code Vestimentaire",
        description: "Tenue de soirée élégante. Palette suggérée : lilas, blanc, doré, tons pastels."
      },
      contact: {
        title: "Contact",
        description: "Pour toute question, n'hésitez pas à nous contacter."
      },
      planning: {
        title: "Planning Détaillé",
        description: "Le programme complet de la journée sera communiqué prochainement."
      }
    },
    gifts: {
      title: "Cadeaux & Contributions",
      intro: "Votre présence à nos côtés est le plus beau des cadeaux. Si vous souhaitez nous offrir une contribution, voici les moyens mis à votre disposition :",
      methods: [
        {
          name: "PayPal",
          instruction: "Scannez le QR code pour contribuer via PayPal"
        },
        {
          name: "Revolut",
          instruction: "Scannez le QR code pour contribuer via Revolut"
        }
      ],
      thankyou: "Merci infiniment pour votre générosité et votre soutien."
    },
    rsvp: {
      title: "Confirmez votre Présence",
      intro: "Nous serions honorés de vous compter parmi nous lors de cette journée spéciale.",
      form: {
        firstName: "Prénom",
        lastName: "Nom",
        phone: "Téléphone",
        email: "Email",
        attendance: "Présence",
        attendanceYes: "Oui, je serai présent(e)",
        attendanceNo: "Non, je ne pourrai pas être présent(e)",
        guestCount: "Nombre d'invités",
        message: "Message (optionnel)",
        submit: "Confirmer ma présence"
      },
      success: "Merci pour votre confirmation ! Nous avons hâte de célébrer avec vous.",
      error: "Une erreur s'est produite. Veuillez réessayer."
    },
    footer: {
      text: "Nelly & Cyrille — 2026",
      madeWith: "Avec amour"
    },
    guestbook: {
      title: "Livre d'Or",
      subtitle: "Partagez vos vœux et messages pour les mariés",
      form: {
        name: "Votre prénom",
        city: "Votre ville",
        message: "Votre message",
        messagePlaceholder: "Écrivez vos vœux de bonheur pour Nelly & Cyrille...",
        isPrivate: "Message privé (visible uniquement par les mariés)",
        submit: "Envoyer mon message",
        submitting: "Envoi en cours..."
      },
      success: "Merci pour votre message ! Il a été ajouté au livre d'or.",
      error: "Une erreur s'est produite. Veuillez réessayer.",
      empty: "Soyez le premier à laisser un message !",
      messagesTitle: "Messages de nos proches"
    },
    accommodation: {
      title: "Hébergement",
      subtitle: "Où séjourner à Abidjan",
      intro: "Voici nos recommandations d'hébergement pour votre séjour. Nous vous conseillons de réserver rapidement pour bénéficier des meilleurs tarifs.",
      categories: [
        {
          name: "Premium",
          icon: "star",
          hotels: [
            { name: "Sofitel Abidjan Hôtel Ivoire", area: "Cocody", price: "À partir de 150€ / 225 CAD par nuit", features: "5 étoiles, piscine, spa, vue lagune", url: "https://sofitel.accor.com/fr/hotels/8844.html" },
            { name: "Radisson Blu Hotel Abidjan Airport", area: "Port-Bouët", price: "À partir de 120€ / 180 CAD par nuit", features: "5 étoiles, proche aéroport, piscine", url: "https://www.radissonhotels.com/fr-fr/hotels/radisson-blu-abidjan-airport/mariages" },
            { name: "Pullman Abidjan", area: "Plateau", price: "À partir de 130€ / 195 CAD par nuit", features: "5 étoiles, centre-ville, restaurant", url: "https://all.accor.com/hotel/1146/index.fr.shtml" }
          ]
        },
        {
          name: "Confort",
          icon: "home",
          hotels: [
            { name: "Hôtel Tiama", area: "Plateau", price: "À partir de 80€ / 120 CAD par nuit", features: "4 étoiles, centre-ville, wifi", url: "https://www.booking.com/hotel/ci/tiama.fr.html" },
            { name: "Onomo Hotel Abidjan", area: "Marcory", price: "À partir de 70€ / 105 CAD par nuit", features: "4 étoiles, moderne, restaurant", url: "https://fr.hotels.com/Hotel-Search?selected=8260764&locale=fr_FR&HotelID=8260764" },
            { name: "Seen Hotel Abidjan", area: "Plateau", price: "À partir de 75€ / 115 CAD par nuit", features: "4 étoiles, piscine, vue mer", url: "https://www.booking.com/hotel/ci/seen-abidjan-plateau.fr.html" }
          ]
        },
        {
          name: "Budget",
          icon: "wallet",
          hotels: [
            { name: "Hôtel Belle Côte", area: "Cocody", price: "À partir de 40€ / 60 CAD par nuit", features: "3 étoiles, propre, wifi", url: "https://www.hotelbellecoteci.com/index.php" },
            { name: "Résidence Bertille", area: "Deux Plateaux", price: "À partir de 35€ / 55 CAD par nuit", features: "Appartement, cuisine équipée", url: "https://residencebertille.com/fr/" },
            { name: "Hôtel Wafou", area: "Plateau", price: "À partir de 45€ / 70 CAD par nuit", features: "3 étoiles, central, climatisé", url: "https://fr.hotels.com/ho609347808/le-wafou-abidjan-cote-d-ivoire" }
          ]
        }
      ],
      alternative: {
        title: "Autres types de logements",
        description: "Des alternatives comme des appartements, des résidences meublées ou des logements chez l'habitant sont aussi disponibles en suivant ce lien.",
        linkText: "Découvrir les logements",
        url: "https://www.cozycozy.com/fr/location-vacances-abidjan"
      },
      tips: {
        title: "Conseils",
        items: [
          "Réservez via Booking.com ou directement auprès des hôtels",
          "Les quartiers Cocody et Deux Plateaux sont les plus proches des lieux de cérémonie",
          "Prévoyez votre réservation plusieurs semaines à l'avance"
        ]
      }
    },
    transport: {
      title: "Transport",
      subtitle: "Comment se déplacer",
      sections: [
        {
          title: "Arrivée à l'aéroport",
          icon: "plane",
          content: "L'aéroport international Félix Houphouët-Boigny (ABJ) est situé à environ 20-30 minutes du centre-ville selon le trafic.",
          tips: [
            "Des taxis officiels sont disponibles à la sortie de l'aéroport",
            "Tarif moyen aéroport → Cocody : 10 000 - 15 000 FCFA (15-25€)",
            "Nous pouvons organiser un transfert pour vous - contactez-nous"
          ]
        },
        {
          title: "Déplacements en ville",
          icon: "car",
          content: "Plusieurs options s'offrent à vous pour vous déplacer à Abidjan :",
          options: [
            { name: "Taxi compteur", desc: "Taxis orange, négociez le prix avant de monter" },
            { name: "VTC (Uber, Yango)", desc: "Applications disponibles, paiement par carte ou espèces" },
            { name: "Location de voiture", desc: "Avec chauffeur recommandé pour les non-initiés" }
          ]
        },
        {
          title: "Le jour J",
          icon: "calendar",
          content: "Pour le jour du mariage, nous organiserons des navettes entre les différents lieux. Les détails seront communiqués ultérieurement.",
          note: "Prévoyez toujours du temps supplémentaire pour les déplacements - le trafic à Abidjan peut être dense."
        }
      ]
    },
    contacts: {
      title: "Contacts",
      subtitle: "Nous sommes là pour vous",
      intro: "N'hésitez pas à nous contacter pour toute question concernant le mariage.",
      categories: [
        {
          title: "Les Mariés",
          icon: "heart",
          contacts: [
            { name: "Cyrille", role: "Marié", email: "cyrilleneninbi@gmail.com", available: true },
            { name: "Nelly", role: "Mariée", email: "kacounelly@gmail.com", available: true }
          ]
        },
        {
          title: "Organisation",
          icon: "clipboard",
          contacts: [
            { name: "Contact Organisation", role: "Coordination générale", email: "cyrilleneninbi@gmail.com", available: true }
          ]
        },
        {
          title: "Urgence Jour J",
          icon: "phone",
          note: "Les numéros d'urgence pour le jour du mariage seront communiqués par email quelques jours avant l'événement."
        }
      ],
      emergency: {
        title: "Numéros utiles en Côte d'Ivoire",
        numbers: [
          { name: "Police", number: "110" },
          { name: "Pompiers", number: "180" },
          { name: "SAMU", number: "185" },
          { name: "Indicatif pays", number: "+225" }
        ]
      }
    }
  },
  en: {
    nav: {
      home: "Home",
      ourStory: "Our Story",
      ourPath: "Our Journey",
      gallery: "Gallery",
      program: "Program",
      faq: "FAQ",
      maps: "Maps",
      infosCI: "Ivory Coast",
      guestbook: "Guestbook",
      accommodation: "Accommodation",
      transport: "Transport",
      contacts: "Contacts",
      practicalInfo: "Practical Info",
      gifts: "Gifts",
      rsvp: "RSVP"
    },
    countdown: {
      title: "Countdown",
      days: "Days",
      hours: "Hours",
      minutes: "Minutes",
      seconds: "Seconds",
      addToCalendar: "Add to Calendar"
    },
    keyMoments: {
      title: "Key Moments",
      subtitle: "Three celebrations to seal our union",
      civil: {
        title: "Civil Wedding",
        date: "August 14, 2026",
        time: "12:00 PM",
        location: "Mairie de Cocody",
        address: "Boulevard des Martyrs, Cocody, Abidjan",
        viewMap: "View on map"
      },
      religious: {
        title: "Religious Ceremony",
        date: "August 14, 2026",
        time: "3:00 PM",
        location: "Paroisse Sainte Cécile",
        address: "Deux plateaux, Cocody, Abidjan",
        viewMap: "View on map"
      },
      reception: {
        title: "Reception",
        date: "August 14, 2026",
        time: "5:00 PM",
        location: "Espace JECKAD",
        address: "Angré 7ème tranche, Rue L155, Cocody, Abidjan",
        viewMap: "View on map"
      }
    },
    gallery: {
      title: "Photo Gallery",
      subtitle: "Our most beautiful moments",
      teasing: {
        title: "Before the Big Day",
        description: "Discover some moments of our story before the wedding"
      },
      wedding: {
        title: "Wedding Photos",
        description: "Photos will be added after August 14, 2026",
        comingSoon: "Coming Soon"
      }
    },
    program: {
      title: "Program of the Day",
      subtitle: "The schedule of our special day",
      comingSoon: "Detailed program will be shared soon",
      timeline: [
        {
          time: "12:00 PM",
          title: "Civil Ceremony",
          location: "Mairie de Cocody",
          description: "Official ceremony with our loved ones"
        },
        {
          time: "3:00 PM",
          title: "Religious Ceremony",
          location: "Paroisse Sainte Cécile",
          description: "Blessing of our union before God"
        },
        {
          time: "5:00 PM",
          title: "Welcome Cocktail",
          location: "Espace JECKAD",
          description: "Convivial moment with our guests"
        },
        {
          time: "6:00 PM",
          title: "Dinner & Party",
          location: "Espace JECKAD",
          description: "Celebration and festivities"
        }
      ]
    },
    faq: {
      title: "Frequently Asked Questions",
      subtitle: "Everything you need to know",
      questions: [
        {
          question: "What time do the ceremonies start?",
          answer: "Civil wedding at Mairie de Cocody at 12:00 PM, religious ceremony at Paroisse Sainte Cécile at 3:00 PM, welcome cocktail at Espace JECKAD at 5:00 PM, then dinner and party at 6:00 PM. We recommend arriving 30 minutes early."
        },
        {
          question: "Can I bring a guest?",
          answer: "Yes, if your invitation includes a plus-one. Please confirm the exact number of attendees in your RSVP."
        },
        {
          question: "How do I confirm my attendance?",
          answer: "Go to the RSVP section of this website and fill out the form. You will receive a confirmation email at the address provided."
        },
        {
          question: "Where can I stay in Abidjan?",
          answer: "We recommend Cocody, Deux Plateaux, and Plateau areas. Several hotels are available at different budgets (from €35/CAD 55 to €150/CAD 225 per night). Check the Accommodation section for our recommendations. Book early for better rates."
        },
        {
          question: "How do I get to the venues?",
          answer: "Taxis and ride-sharing apps (Uber, Yango) are available throughout Abidjan. Allow extra time for traffic. Exact addresses and maps are available in the Maps and Practical Info sections."
        },
        {
          question: "Will there be a photographer/videographer?",
          answer: "Yes, professionals will be present. Feel free to take your own photos and share them with us!"
        },
        {
          question: "How can I contribute for gifts?",
          answer: "Your presence is the best gift! If you wish to contribute, PayPal and Revolut links (with QR codes) are available in the Gifts section. Mobile Money options will be available soon."
        },
        {
          question: "Who should I contact in case of emergency on the day?",
          answer: "Emergency contact numbers will be shared by email a few days before the event."
        },
        {
          question: "What is the dress code?",
          answer: "Elegant evening attire. We suggest lilac, white, gold, and pastel tones to match our theme."
        },
        {
          question: "Are there safety precautions to take?",
          answer: "Abidjan is a welcoming city. Keep valuables secure and avoid traveling alone late at night. Ceremony areas are safe."
        }
      ]
    },
    maps: {
      title: "Ceremony Locations",
      subtitle: "Find us at the following addresses",
      locations: [
        {
          name: "Mairie de Cocody",
          event: "Civil Wedding",
          address: "Boulevard des Martyrs, Cocody, Abidjan",
          mapQuery: "Mairie+de+Cocody,+Abidjan,+Côte+d'Ivoire"
        },
        {
          name: "Paroisse Sainte Cécile",
          event: "Religious Ceremony",
          address: "Deux Plateaux Vallon, Cocody, Abidjan",
          mapQuery: "Paroisse+Sainte+Cécile,+Deux+Plateaux,+Abidjan"
        },
        {
          name: "Espace JECKAD",
          event: "Reception",
          address: "Angré 7ème tranche, Rue L155, Cocody, Abidjan",
          mapQuery: "Espace+JECKAD,+Angré,+Cocody,+Abidjan"
        }
      ]
    },
    ivoryCoastInfo: {
      title: "Welcome to Abidjan",
      subtitle: "The Pearl of the Lagoons",
      intro: "Practical information to prepare your stay in Ivory Coast",
      sections: [
        {
          title: "Weather in August",
          icon: "sun",
          content: "Temperatures: 24-28°C (75-82°F). Rainy season, bring an umbrella. High humidity."
        },
        {
          title: "Currency",
          icon: "currency",
          content: "CFA Franc (XOF). 1 EUR ≈ 656 FCFA. Exchange at airport or banks."
        },
        {
          title: "Electricity",
          icon: "plug",
          content: "220V, European plugs (type C and E). Adapter rarely needed."
        },
        {
          title: "Phone & Internet",
          icon: "wifi",
          content: "Country code +225. Local SIM cards (Orange, MTN) available everywhere. Excellent 4G."
        },
        {
          title: "Language",
          icon: "language",
          content: "French (official). English understood in hotels and tourist areas."
        },
        {
          title: "Transportation",
          icon: "car",
          content: "Taxis, ride-sharing (Uber, Yango). Félix Houphouët-Boigny Airport (ABJ) 20-30 min from center."
        }
      ]
    },
    hero: {
      names: "Nelly & Cyrille",
      subtitle: "In the gentleness of her gaze, I found my strength. In the grace of her heart, I discovered my anchor. Nelly, light of my days, with you, love is no longer a dream but a promise kept.",
      verse: "A cord of three strands is not quickly broken",
      verseRef: "Ecclesiastes 4:12",
      cta1: "Discover our story",
      cta2: "RSVP",
      date: "August 14, 2026"
    },
    ourStory: {
      title: "Our Story",
      intro: "A story woven with patience, faith, and grace beyond our understanding.",
      paragraphs: [
        "When our paths crossed, we weren't looking for love. We were seeking peace, clarity, direction. And in that search, God placed us face to face. Nelly, with her rare gentleness and quiet strength, entered my life like an obvious truth.",
        "She doesn't proclaim her elegance, she wears it. She doesn't claim her strength, she embodies it. In her silences, I learned humility. In her laughter, I discovered pure joy. In her unwavering faith, I found my own courage to believe even greater.",
        "This isn't a love-at-first-sight story. It's a story of conscious building. Day after day, we chose to understand each other, to support one another, to grow together. We learned that true love isn't a fleeting emotion, but a daily commitment.",
        "Nelly taught me patience. She showed me that true strength lies in gentleness, that real wisdom is nourished by silence and listening. With her, I understood that getting married isn't an end, but a beginning – the start of a shared life under God's benevolent gaze.",
        "Today, we choose to say yes to each other. Not out of naivety, but conviction. Not for ease, but commitment. With all of you, witnesses to our love, we write this new chapter of our story."
      ]
    },
    ourPath: {
      title: "Our Journey",
      subtitle: "In the shadow of His presence, we grew together",
      verse: "Charm is deceptive, and beauty is fleeting; but a woman who fears the LORD is to be praised.",
      verseRef: "Proverbs 31:30",
      paragraphs: [
        "Our path wasn't drawn in agitation, but in the silence of prayer. We walked together, not by fleeing our imperfections, but by welcoming them with grace. With each trial, we chose faith over fear. With each doubt, we chose trust over withdrawal.",
        "In the shadow of His presence, we learned unity. Not uniformity, but harmony. We understood that our differences aren't obstacles, but complements. That our strengths multiply when shared, and our weaknesses lighten when carried by two.",
        "Today, we see far ahead. A family built on faith. A home where peace and stability reign. A life where our children will grow knowing they are loved, not by chance, but by choice. Together, under His presence, we build our future with confidence."
      ]
    },
    practicalInfo: {
      title: "Practical Information",
      events: {
        title: "Ceremony Schedule",
        civil: {
          title: "Civil Wedding",
          date: "August 14, 2026",
          time: "12:00 PM",
          location: "Abidjan, Côte d'Ivoire"
        },
        religious: {
          title: "Religious Ceremony",
          date: "August 14, 2026",
          time: "3:00 PM",
          location: "Paroisse Sainte Cécile des 2 Plateaux Vallon, Abidjan"
        },
        reception: {
          title: "Reception",
          date: "August 14, 2026",
          time: "5:00 PM",
          location: "Espace JECKAD, Abidjan"
        }
      },
      dressCode: {
        title: "Dress Code",
        description: "Elegant evening attire. Suggested palette: lilac, white, gold, pastel tones."
      },
      contact: {
        title: "Contact",
        description: "For any questions, please feel free to contact us."
      },
      planning: {
        title: "Detailed Schedule",
        description: "The complete program for the day will be shared soon."
      }
    },
    gifts: {
      title: "Gifts & Contributions",
      intro: "Your presence by our side is the most beautiful gift. If you wish to offer us a contribution, here are the available options:",
      methods: [
        {
          name: "PayPal",
          instruction: "Scan the QR code to contribute via PayPal"
        },
        {
          name: "Revolut",
          instruction: "Scan the QR code to contribute via Revolut"
        }
      ],
      thankyou: "Thank you so much for your generosity and support."
    },
    rsvp: {
      title: "Confirm Your Attendance",
      intro: "We would be honored to count you among us on this special day.",
      form: {
        firstName: "First Name",
        lastName: "Last Name",
        phone: "Phone",
        email: "Email",
        attendance: "Attendance",
        attendanceYes: "Yes, I will attend",
        attendanceNo: "No, I won't be able to attend",
        guestCount: "Number of Guests",
        message: "Message (optional)",
        submit: "Confirm Attendance"
      },
      success: "Thank you for your confirmation! We can't wait to celebrate with you.",
      error: "An error occurred. Please try again."
    },
    footer: {
      text: "Nelly & Cyrille — 2026",
      madeWith: "Made with love"
    },
    guestbook: {
      title: "Guestbook",
      subtitle: "Share your wishes and messages for the newlyweds",
      form: {
        name: "Your first name",
        city: "Your city",
        message: "Your message",
        messagePlaceholder: "Write your wishes for Nelly & Cyrille...",
        isPrivate: "Private message (visible only to the couple)",
        submit: "Send my message",
        submitting: "Sending..."
      },
      success: "Thank you for your message! It has been added to the guestbook.",
      error: "An error occurred. Please try again.",
      empty: "Be the first to leave a message!",
      messagesTitle: "Messages from our loved ones"
    },
    accommodation: {
      title: "Accommodation",
      subtitle: "Where to stay in Abidjan",
      intro: "Here are our accommodation recommendations for your stay. We advise you to book early for the best rates.",
      categories: [
        {
          name: "Premium",
          icon: "star",
          hotels: [
            { name: "Sofitel Abidjan Hôtel Ivoire", area: "Cocody", price: "From €150 / CAD 225 per night", features: "5 stars, pool, spa, lagoon view", url: "https://sofitel.accor.com/fr/hotels/8844.html" },
            { name: "Radisson Blu Hotel Abidjan Airport", area: "Port-Bouët", price: "From €120 / CAD 180 per night", features: "5 stars, near airport, pool", url: "https://www.radissonhotels.com/fr-fr/hotels/radisson-blu-abidjan-airport/mariages" },
            { name: "Pullman Abidjan", area: "Plateau", price: "From €130 / CAD 195 per night", features: "5 stars, city center, restaurant", url: "https://all.accor.com/hotel/1146/index.fr.shtml" }
          ]
        },
        {
          name: "Comfort",
          icon: "home",
          hotels: [
            { name: "Hôtel Tiama", area: "Plateau", price: "From €80 / CAD 120 per night", features: "4 stars, city center, wifi", url: "https://www.booking.com/hotel/ci/tiama.fr.html" },
            { name: "Onomo Hotel Abidjan", area: "Marcory", price: "From €70 / CAD 105 per night", features: "4 stars, modern, restaurant", url: "https://fr.hotels.com/Hotel-Search?selected=8260764&locale=fr_FR&HotelID=8260764" },
            { name: "Seen Hotel Abidjan", area: "Plateau", price: "From €75 / CAD 115 per night", features: "4 stars, pool, sea view", url: "https://www.booking.com/hotel/ci/seen-abidjan-plateau.fr.html" }
          ]
        },
        {
          name: "Budget",
          icon: "wallet",
          hotels: [
            { name: "Hôtel Belle Côte", area: "Cocody", price: "From €40 / CAD 60 per night", features: "3 stars, clean, wifi", url: "https://www.hotelbellecoteci.com/index.php" },
            { name: "Résidence Bertille", area: "Deux Plateaux", price: "From €35 / CAD 55 per night", features: "Apartment, equipped kitchen", url: "https://residencebertille.com/fr/" },
            { name: "Hôtel Wafou", area: "Plateau", price: "From €45 / CAD 70 per night", features: "3 stars, central, air-conditioned", url: "https://fr.hotels.com/ho609347808/le-wafou-abidjan-cote-d-ivoire" }
          ]
        }
      ],
      alternative: {
        title: "Other accommodation options",
        description: "Alternatives such as apartments, furnished residences or homestays are also available through this link.",
        linkText: "Browse accommodations",
        url: "https://www.cozycozy.com/en-ae/abidjan-apartments"
      },
      tips: {
        title: "Tips",
        items: [
          "Book via Booking.com or directly with hotels",
          "Cocody and Deux Plateaux areas are closest to ceremony venues",
          "Plan your reservation several weeks in advance"
        ]
      }
    },
    transport: {
      title: "Transport",
      subtitle: "How to get around",
      sections: [
        {
          title: "Airport Arrival",
          icon: "plane",
          content: "Félix Houphouët-Boigny International Airport (ABJ) is located about 20-30 minutes from the city center depending on traffic.",
          tips: [
            "Official taxis are available at the airport exit",
            "Average fare airport → Cocody: 10,000 - 15,000 FCFA (€15-25)",
            "We can arrange a transfer for you - contact us"
          ]
        },
        {
          title: "Getting around the city",
          icon: "car",
          content: "Several options are available to get around Abidjan:",
          options: [
            { name: "Metered taxi", desc: "Orange taxis, negotiate the price before getting in" },
            { name: "Ride-sharing (Uber, Yango)", desc: "Apps available, pay by card or cash" },
            { name: "Car rental", desc: "With driver recommended for first-timers" }
          ]
        },
        {
          title: "Wedding Day",
          icon: "calendar",
          content: "For the wedding day, we will organize shuttles between the different venues. Details will be communicated later.",
          note: "Always allow extra time for travel - traffic in Abidjan can be heavy."
        }
      ]
    },
    contacts: {
      title: "Contacts",
      subtitle: "We're here for you",
      intro: "Don't hesitate to contact us for any questions about the wedding.",
      categories: [
        {
          title: "The Couple",
          icon: "heart",
          contacts: [
            { name: "Cyrille", role: "Groom", email: "cyrilleneninbi@gmail.com", available: true },
            { name: "Nelly", role: "Bride", email: "kacounelly@gmail.com", available: true }
          ]
        },
        {
          title: "Organization",
          icon: "clipboard",
          contacts: [
            { name: "Organization Contact", role: "General coordination", email: "cyrilleneninbi@gmail.com", available: true }
          ]
        },
        {
          title: "Wedding Day Emergency",
          icon: "phone",
          note: "Emergency numbers for the wedding day will be shared by email a few days before the event."
        }
      ],
      emergency: {
        title: "Useful numbers in Ivory Coast",
        numbers: [
          { name: "Police", number: "110" },
          { name: "Fire Department", number: "180" },
          { name: "Emergency Medical", number: "185" },
          { name: "Country code", number: "+225" }
        ]
      }
    }
  }
};

export const images = {
  hero: "https://customer-assets.emergentagent.com/job_cyrille-nelly/artifacts/mnv0kyd3_WhatsApp%20Image%202025-12-31%20at%2018.35.39.jpeg",
  qrPaypal: "https://customer-assets.emergentagent.com/job_91f8bc62-fd53-42f2-b84e-836f0010836a/artifacts/mxo2prpe_qrcode%20%282%29.png",
  qrRevolut: "https://customer-assets.emergentagent.com/job_cyrille-nelly/artifacts/06j0x4q2_WhatsApp%20Image%202025-12-31%20at%2016.27.50.jpeg",
  abidjan: [
    "https://images.unsplash.com/photo-1648770664367-54d43741edf1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxBYmlkamFuJTIwY2l0eXNjYXBlfGVufDB8fHx8MTc2NzM3MDM3OHww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1763454242946-948f870d730c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBza3lsaW5lJTIwQWZyaWNhfGVufDB8fHx8MTc2NzM3MDM4NXww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1756061916299-643c5b65858e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBza3lsaW5lJTIwQWZyaWNhfGVufDB8fHx8MTc2NzM3MDM4NXww&ixlib=rb-4.1.0&q=85"
  ],
  gallery: [
    {
      src: "https://customer-assets.emergentagent.com/job_cyrille-nelly/artifacts/m3jwk1fu_WhatsApp%20Image%202025-12-31%20at%2018.32.55.jpeg",
      alt: "Nelly & Cyrille - Photo 1",
      caption: "Moment précieux"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_cyrille-nelly/artifacts/szydiny6_WhatsApp%20Image%202025-12-31%20at%2018.32.57.jpeg",
      alt: "Nelly & Cyrille - Photo 2",
      caption: "Notre amour"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_cyrille-nelly/artifacts/4h0bpojn_WhatsApp%20Image%202025-12-31%20at%2018.32.57%20%281%29.jpeg",
      alt: "Nelly & Cyrille - Photo 3",
      caption: "Ensemble"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_cyrille-nelly/artifacts/l41wz3t2_WhatsApp%20Image%202025-12-31%20at%2018.32.57%20%283%29.jpeg",
      alt: "Nelly & Cyrille - Photo 4",
      caption: "Notre histoire"
    },
    {
      src: "https://customer-assets.emergentagent.com/job_7097c2e0-21ce-4e68-8e3b-1ddc634525be/artifacts/2myt9s47_7b668d06-b0c8-4358-910a-dba18c5b193b.jpeg",
      alt: "Nelly & Cyrille - Photo 5",
      caption: "Tendresse"
    }
  ]
};
